module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('section', {
    staticClass: "main-content"
  }, [_c('div', {
    staticClass: "main-block"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-12"
  }, [_c('div', {
    staticClass: "bck-index bck-articles"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "articles-items"
  }, [_c('div', {
    staticClass: "articles-box contact-box"
  }, [_c('div', {
    staticClass: "row strict"
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "col-md-7 text-bg"
  }, [_c('div', {
    staticClass: "text"
  }, [_vm._m(2), _vm._v(" "), _c('form', {
    staticClass: "contact-form",
    attrs: {
      "action": "",
      "method": "post"
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "sr-only",
    attrs: {
      "for": "name"
    }
  }, [_vm._v("Example label")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.name),
      expression: "name"
    }],
    staticClass: "form-control form-control-sm",
    attrs: {
      "type": "text",
      "id": "name",
      "placeholder": "姓名"
    },
    domProps: {
      "value": (_vm.name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.name = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "sr-only",
    attrs: {
      "for": "email"
    }
  }, [_vm._v("Another label")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.email),
      expression: "email"
    }],
    staticClass: "form-control form-control-sm",
    attrs: {
      "type": "text",
      "id": "email",
      "placeholder": "Email"
    },
    domProps: {
      "value": (_vm.email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.email = $event.target.value
      }
    }
  })])]), _vm._v(" "), _vm._m(3), _vm._v(" "), _vm._m(4)]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary btn-block",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.addContact
    }
  }, [_vm._v("送出")])])])])])])])])])])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h3', {
    staticClass: "title sr-only"
  }, [_c('span', [_vm._v("About us")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-md-5"
  }, [_c('figure', {
    staticClass: "pic articles-pic mb-0 pic-left"
  }, [_c('img', {
    staticClass: "img-fluid",
    attrs: {
      "src": "/static/images/contact.jpg"
    }
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h4', {
    staticClass: "title text-primary"
  }, [_vm._v("請填好以下的回覆表格"), _c('br'), _vm._v("我們會盡快和你聯絡")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "sr-only",
    attrs: {
      "for": "mobile"
    }
  }, [_vm._v("Another label")]), _vm._v(" "), _c('input', {
    staticClass: "form-control form-control-sm",
    attrs: {
      "type": "text",
      "id": "mobile",
      "placeholder": "手機"
    }
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "sr-only",
    attrs: {
      "for": "message"
    }
  }, [_vm._v("Example textarea")]), _vm._v(" "), _c('textarea', {
    staticClass: "form-control form-control-sm",
    attrs: {
      "id": "message",
      "rows": "4",
      "placeholder": "留言訊息/婚禮歌曲使用video上傳"
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-762fcfc8","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/Contact.vue
// module id = 166
// module chunks = 1